import styled from 'styled-components';
import { Calendar } from 'antd';

export const StyledCalendar = styled(Calendar)`
    padding: 10px;
    border-radius: 8px;
`;
